<div class="alert-icon">
  <ng-content></ng-content>
</div>
